export default "__VITE_ASSET__BIswav70__"